import { WopeeReporter } from './wopeeReporter.js';

export default WopeeReporter;
